<template>
    <v-list>
        <v-list-item
                v-for="item in popClients"
        >
            <v-list-item-avatar>
                <v-avatar class="m-auto"
                          size="40px"
                          color="accent"
                >
                    <img  v-if="item.clientLogo!=null" :src="$root.docsUrl+item.clientLogo">
                    <img v-else src="../../assets/noavatar.png" height="40" width="40"/>
                </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title ><span class="client-name">{{item.client}}</span></v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
                <span class="count-activates">{{item.count}}</span>
            </v-list-item-action>
        </v-list-item>
    </v-list>
</template>

<script>
    export default {
        name: "PopClientsList",
        props:{
            lastDays: {
                type: Number,
                default: 0
            },
            limited:{
                type:Boolean,
                default:false
            }
        },
        mounted(){
            this.getPopClients()
        },
        computed:{
            popClients(){
                return this.$store.state.Statistic.popClients
            },
        },
        methods:{
            getPopClients(){
                let params={
                    lastDays:this.lastDays,
                    isLimit:this.limited
                }
                this.$store.dispatch("Statistic/loadPopClients", params).catch(err=>{
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки клиентов!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            }
        },
        watch:{
            lastDays(value){
                this.getPopClients()
            }
        }

    }
</script>

<style scoped>
    .client-name{
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 20px;
        color:black;
    }

    .count-activates{
        font-weight: 600;
        font-size: 32px;
        line-height: 40px;
        text-align: right;
        color: #000000;
    }
</style>